$(document).ready(() => {
    $('.share-toggle').on('click', (e) => {
        e.preventDefault();
        $('.share-container').fadeToggle(300);
    });
    
    $('a.wishlist').on('click', (e) => { 
        e.preventDefault(); 
        let btn = e.target.parentElement;
        let isAdded = $(btn).attr('aria-added');

        if(isAdded == 'true'){
            $(btn).attr('aria-added','false');
        }
        else{
            $(btn).attr('aria-added','true');
        }
    });

});